<!--
 * @Descripttion: 备忘提醒 - 提醒设置组件（提醒时间/是否同步日历/重复提醒），新建编辑页与设提醒弹窗共用
 * @version:
 * @Author: geory
 * @Date: 2026-08-14 20:30:00
 * @LastEditors: geory
 * @LastEditTime: 2026-08-14 20:30:00
-->
<template>
    <div class="mrs">
        <div class="mrsRow">
            <span class="mrsLabel">提醒时间</span>
            <div class="mrsControl">
                <el-date-picker v-if="!repeatRemind" ref="onceDatePicker" v-model="onceDate" type="datetime"
                    placeholder="选择时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
                    :picker-options="pickerOptions" popper-class="memoTimePopper" append-to-body
                    @focus="onPickerTouch" @click="onPickerTouch"
                    @change="onOnceChange"></el-date-picker>
                <div v-else class="mrsTimeSel">
                    <select class="mrsSelect" :value="hour" @change="onHourChange">
                        <option v-for="h in 24" :key="'h'+h" :value="h-1">{{pad(h-1)}}</option>
                    </select>
                    <span class="mrsColon">:</span>
                    <select class="mrsSelect" :value="minute" @change="onMinuteChange">
                        <option v-for="m in 60" :key="'m'+m" :value="m-1">{{pad(m-1)}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div v-if="!isWindows" class="mrsRow">
            <span class="mrsLabel">是否同步日历</span>
            <el-switch v-model="syncCalendar" active-color="#FB5D5C"
                :disabled="!remindEnabled" @change="emitChange"></el-switch>
        </div>
        <div class="mrsRow">
            <span class="mrsLabel">重复提醒</span>
            <el-switch v-model="repeatRemind" active-color="#FB5D5C"
                :disabled="!remindEnabled" @change="onRepeatRemindChange"></el-switch>
        </div>
        <div v-if="repeatRemind && remindEnabled" class="mrsRepeat">
            <div class="mrsRepeatRow">
                <span class="mrsRepeatLabel">重复方式</span>
                <div class="mrsRepeatTypes">
                    <div v-for="t in repeatTypes" :key="t.type"
                        :class="['mrsRepeatType', repeatType === t.type ? 'mrsRepeatTypeSel' : '']"
                        @click="selectRepeatType(t.type)">{{t.label}}</div>
                </div>
            </div>
            <div v-if="repeatType === 2" class="mrsRepeatRow">
                <span class="mrsRepeatLabel">每周几</span>
                <div class="mrsWeekdays">
                    <div v-for="w in 7" :key="'w'+w"
                        :class="['mrsWeekday', weekDays.indexOf(w) >= 0 ? 'mrsWeekdaySel' : '']"
                        @click="toggleWeekday(w)">{{weekdayNames[w]}}</div>
                </div>
            </div>
            <div v-if="repeatType === 3" class="mrsRepeatRow">
                <span class="mrsRepeatLabel">每月几号</span>
                <select class="mrsSelect" :value="monthDay" @change="onMonthDayChange">
                    <option v-for="d in 31" :key="'d'+d" :value="d">{{d}}</option>
                </select>
                <span class="mrsSelectSuffix">日</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        DatePicker,
        Switch
    } from 'element-ui';
    Vue.use(DatePicker)
    Vue.use(Switch)

    import {
        setSyncCalendarDefault,
        isWindowsPlatform
    } from '@/service/memoRemindService'

    function pad(n) {
        return n < 10 ? "0" + n : "" + n;
    }

    function formatDate(date) {
        return (
            date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate()) +
            " " + pad(date.getHours()) + ":" + pad(date.getMinutes())
        );
    }

    export default {
        name: "MemoRemindSetting",
        props: {
            //{remindType,notRepeatTime,byDayTime,byMonthDay,byWeekDay,syncCalendar}
            value: {
                type: Object,
                default: function() {
                    return {};
                }
            }
        },
        data() {
            return {
                repeatTypes: [
                    { type: 1, label: "每天" },
                    { type: 2, label: "每周" },
                    { type: 3, label: "每月" },
                ],
                weekdayNames: ["", "一", "二", "三", "四", "五", "六", "日"],
                pickerOptions: {
                    disabledDate(time) {
                        // 不允许选择今天之前的日期
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                    }
                },
                //内部状态
                onceDate: "",
                syncCalendar: false,
                repeatRemind: false,
                repeatType: 1,
                weekDays: [1],
                monthDay: 1,
                hour: 9,
                minute: 0,
            }
        },
        computed: {
            //是否已设置提醒（决定同步日历/重复提醒开关是否可用）
            remindEnabled() {
                return this.repeatRemind || !!this.onceDate;
            },
            //Windows版停用系统日历同步，隐藏「是否同步日历」开关
            isWindows() {
                return isWindowsPlatform();
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.initFromValue(val || {});
                },
                deep: true,
            },
            //「重复提醒」会 v-if 掉日期选择器，重新挂载后要重新绑监听
            repeatRemind() {
                this.$nextTick(() => this.bindPickerPopperFit());
            },
        },
        methods: {
            pad,
            // 面板开关由 picker 自己控制（点输入框/键盘聚焦/程序调用都可能触发），
            // 这里统一监听 pickerVisible：开→挂上自适应，关→清理，不依赖某一次点击。
            bindPickerPopperFit() {
                const pk = this.$refs.onceDatePicker;
                if (!pk || this._memoPicker === pk) {
                    return;
                }
                this.unbindPickerPopperFit();
                this._memoPicker = pk;
                this._memoPopperVisibleWatch = pk.$watch('pickerVisible', (visible) => {
                    if (visible) {
                        this.startMemoPopperFit();
                    } else {
                        this.clearMemoPopperWatch();
                    }
                });
            },
            unbindPickerPopperFit() {
                if (typeof this._memoPopperVisibleWatch === 'function') {
                    this._memoPopperVisibleWatch();
                    this._memoPopperVisibleWatch = null;
                }
                this._memoPicker = null;
                this.clearMemoPopperWatch();
            },
            // 兼容旧的触发方式：聚焦/点击输入框时确保监听已挂上
            onPickerTouch() {
                this.bindPickerPopperFit();
            },
            startMemoPopperFit() {
                // 面板是 popper.js 动态插入 body 的，插入和首次定位可能晚一帧
                this.$nextTick(() => {
                    if (this._memoFitRaf) {
                        cancelAnimationFrame(this._memoFitRaf);
                    }
                    this._memoFitRaf = requestAnimationFrame(() => {
                        this._memoFitRaf = null;
                        this.fitMemoTimePopper();
                    });
                });
            },
            fitMemoTimePopper() {
                const panel = this.getMemoPopper();
                if (!panel) {
                    return;
                }
                // 面板每次被 popper.js 重新定位（弹出/翻转/跟随滚动）都会改 style，
                // 跟着它重新判断，避免只在弹出一瞬间算一次而残留错误状态
                if (this._memoPopperEl !== panel) {
                    this.disconnectMemoPopperObserver();
                    this._memoPopperEl = panel;
                    if (typeof MutationObserver === 'function') {
                        this._memoPopperObserver = new MutationObserver(() => {
                            this.applyMemoPopperFit(panel);
                        });
                        this._memoPopperObserver.observe(panel, {
                            attributes: true,
                            attributeFilter: ['style'],
                        });
                    }
                }
                if (!this._memoPopperResizeHandler) {
                    this._memoPopperResizeHandler = () => this.applyMemoPopperFit(this._memoPopperEl);
                    window.addEventListener('resize', this._memoPopperResizeHandler);
                }
                this.applyMemoPopperFit(panel);
            },
            getMemoPopper() {
                const list = document.querySelectorAll('.memoTimePopper');
                for (let i = 0; i < list.length; i++) {
                    const el = list[i];
                    if (getComputedStyle(el).display !== 'none' && el.offsetWidth) {
                        return el;
                    }
                }
                return null;
            },
            applyMemoPopperFit(panel) {
                if (!panel || !panel.offsetWidth) {
                    return;
                }
                // 面板弹出位置由 popper 以内联 left/top 计算，按该“自然位置”判断是否需要居中
                let left = parseFloat(panel.style.left);
                let top = parseFloat(panel.style.top);
                if (!isFinite(left) || !isFinite(top)) {
                    const rect = panel.getBoundingClientRect();
                    left = rect.left;
                    top = rect.top;
                }
                const width = panel.offsetWidth;
                const height = panel.offsetHeight;
                const vw = window.innerWidth;
                const vh = window.innerHeight;
                const pad = 8;
                // 窗口较窄（<640px）时若面板紧贴/超出边缘就居中；宽窗口只在真正放不下时兜底，平时仍贴近输入框展开
                const narrowW = vw < 640;
                const narrowH = vh < 640;
                const needX = (left < 0 || left + width > vw) ||
                    (narrowW && (left < pad || left + width > vw - pad));
                const needY = (top < 0 || top + height > vh) ||
                    (narrowH && (top < pad || top + height > vh - pad));
                panel.classList.toggle('is-center-x', needX && !needY);
                panel.classList.toggle('is-center-y', !needX && needY);
                panel.classList.toggle('is-center', needX && needY);
            },
            disconnectMemoPopperObserver() {
                if (this._memoPopperObserver) {
                    this._memoPopperObserver.disconnect();
                    this._memoPopperObserver = null;
                }
                this._memoPopperEl = null;
            },
            clearMemoPopperWatch() {
                if (this._memoFitRaf) {
                    cancelAnimationFrame(this._memoFitRaf);
                    this._memoFitRaf = null;
                }
                if (this._memoPopperResizeHandler) {
                    window.removeEventListener('resize', this._memoPopperResizeHandler);
                    this._memoPopperResizeHandler = null;
                }
                this.disconnectMemoPopperObserver();
                const list = document.querySelectorAll('.memoTimePopper');
                for (let i = 0; i < list.length; i++) {
                    list[i].classList.remove('is-center-x', 'is-center-y', 'is-center');
                }
            },
            initFromValue(v) {
                const remindType = v.remindType != null ? Number(v.remindType) : -1;
                this.syncCalendar = !!v.syncCalendar;
                const byDayTime = Number(v.byDayTime) || 0;
                this.hour = Math.floor(byDayTime / 3600000) % 24;
                this.minute = Math.floor(byDayTime / 60000) % 60;
                this.monthDay = Number(v.byMonthDay) || 1;
                this.weekDays = Array.isArray(v.byWeekDay) && v.byWeekDay.length ?
                    v.byWeekDay.map(Number).filter((n) => n >= 1 && n <= 7) : [1];
                if (remindType === 0 && v.notRepeatTime) {
                    this.onceDate = formatDate(new Date(Number(v.notRepeatTime)));
                    this.repeatRemind = false;
                } else if (remindType >= 1 && remindType <= 3) {
                    this.repeatRemind = true;
                    this.repeatType = remindType;
                    // 保留onceDate：开关重复提醒来回切换时，一次性提醒时间不应被清空
                } else {
                    this.onceDate = "";
                    this.repeatRemind = false;
                }
            },
            emitChange() {
                let remindType = -1;
                let notRepeatTime = 0;
                let byDayTime = 0;
                let byMonthDay = 0;
                let byWeekDay = [];
                if (this.repeatRemind) {
                    remindType = this.repeatType;
                    byDayTime = this.hour * 3600000 + this.minute * 60000;
                    if (this.repeatType === 2) {
                        byWeekDay = this.weekDays.slice();
                    }
                    if (this.repeatType === 3) {
                        byMonthDay = this.monthDay || 1;
                    }
                } else if (this.onceDate) {
                    remindType = 0;
                    notRepeatTime = new Date(String(this.onceDate).replace(/-/g, "/")).getTime();
                }
                this.$emit("input", {
                    remindType: remindType,
                    notRepeatTime: notRepeatTime,
                    byDayTime: byDayTime,
                    byMonthDay: byMonthDay,
                    byWeekDay: byWeekDay,
                    syncCalendar: this.syncCalendar,
                });
                // 记住「是否同步日历」的勾选状态，后续默认沿用
                setSyncCalendarDefault(this.syncCalendar);
            },
            selectRepeatType(type) {
                this.repeatType = type;
                if (type === 2 && !this.weekDays.length) {
                    this.weekDays = [1];
                }
                this.emitChange();
            },
            onOnceChange() {
                //选择/清空提醒时间后同步到父组件
                this.emitChange();
            },
            onRepeatRemindChange() {
                //开关重复提醒后同步到父组件
                if (this.repeatRemind) {
                    if (!this.weekDays.length) {
                        this.weekDays = [1];
                    }
                    //首次打开重复提醒且未设置过重复时分时，沿用一次性提醒时间的时分
                    if (this.hour === 0 && this.minute === 0 && this.onceDate) {
                        const d = new Date(String(this.onceDate).replace(/-/g, "/"));
                        if (!isNaN(d.getTime())) {
                            this.hour = d.getHours();
                            this.minute = d.getMinutes();
                        }
                    }
                }
                this.emitChange();
            },
            toggleWeekday(w) {
                const idx = this.weekDays.indexOf(w);
                if (idx >= 0) {
                    this.weekDays.splice(idx, 1);
                } else {
                    this.weekDays.push(w);
                }
                this.emitChange();
            },
            onHourChange(e) {
                this.hour = parseInt(e.target.value, 10);
                this.emitChange();
            },
            onMinuteChange(e) {
                this.minute = parseInt(e.target.value, 10);
                this.emitChange();
            },
            onMonthDayChange(e) {
                this.monthDay = parseInt(e.target.value, 10);
                this.emitChange();
            },
        },
        mounted() {
            this.bindPickerPopperFit();
        },
        created() {
            this.initFromValue(this.value || {});
        },
        beforeDestroy() {
            this.unbindPickerPopperFit();
        },
    }
</script>

<style>
    /* 日期面板(.memoTimePopper 同时带 .el-popper)的层级统一在 common/css/common.css
       里维护：必须高于弹窗遮罩 .v-modal / 弹窗本体，否则弹出的日历会被自己的遮罩
       盖住变灰、日期格也点不动。这里不要重复写 z-index——本文件的 CSS 是懒加载
       chunk，晚于 common.css 注入，同权重会反过来盖掉全局规则。 */

    /* 窄窗口下按默认位置放不下时，把面板居中到可视区内，避免被窗口边缘遮挡 */
    .memoTimePopper.is-center-x {
        position: fixed !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
    }

    .memoTimePopper.is-center-y {
        position: fixed !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
    }

    .memoTimePopper.is-center {
        position: fixed !important;
        left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;
    }
</style>

<style scoped>
    .mrsRow {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 36px;
        padding: 8px 0;
        border-bottom: 1px solid #F5F5F5;
    }

    .mrsLabel {
        font-size: 14px;
        color: #3C3C3C;
        flex-shrink: 0;
    }

    .mrsControl {
        flex: 1;
        margin-left: 16px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .mrsControl .el-date-editor {
        width: 190px;
    }

    .mrsTimeSel {
        display: flex;
        align-items: center;
    }

    .mrsSelect {
        height: 30px;
        border: 1px solid #E5E5E5;
        border-radius: 4px;
        background-color: #fff;
        color: #3C3C3C;
        font-size: 13px;
        padding: 0 4px;
        outline: none;
    }

    .mrsColon {
        color: #3C3C3C;
        margin: 0 6px;
    }

    .mrsSelectSuffix {
        font-size: 13px;
        color: #3C3C3C;
        margin-left: 6px;
    }

    .mrsRepeat {
        background-color: #FAFAFA;
        border-radius: 4px;
        padding: 8px 12px;
        margin-top: 8px;
    }

    .mrsRepeatRow {
        display: flex;
        align-items: center;
        min-height: 32px;
    }

    .mrsRepeatLabel {
        font-size: 13px;
        color: #666666;
        flex-shrink: 0;
        margin-right: 10px;
    }

    .mrsRepeatTypes {
        display: flex;
    }

    .mrsRepeatType {
        padding: 4px 12px;
        border-radius: 4px;
        background-color: #F5F6F6;
        color: #3C3C3C;
        font-size: 13px;
        cursor: pointer;
        margin-right: 8px;
        user-select: none;
    }

    .mrsRepeatTypeSel {
        background-color: #FB5D5C;
        color: #fff;
    }

    .mrsWeekdays {
        display: flex;
    }

    .mrsWeekday {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        border: 1px solid #E5E5E5;
        background-color: #fff;
        color: #3C3C3C;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 6px;
        user-select: none;
    }

    .mrsWeekdaySel {
        background-color: #FB5D5C;
        border-color: #FB5D5C;
        color: #fff;
    }
</style>
